const WEEK_DAYS = [
  "global.sunday", // 0 (ie. American & British Calendars)
  "global.monday",
  "global.tuesday",
  "global.wednesday",
  "global.thursday",
  "global.friday",
  "global.saturday",
  "global.sunday", // 7 (ie. Spanish & Polish Calendars)
];

export function weekDayToTranslationKey(day: number): string {
  return WEEK_DAYS[day];
}